export const convertNumberToBoolean = value => {
  if (value === 0 || value === null) return null;
  if (value === 1) return true;
  if (value === 2) return false;
  if (value === 306) return false;
  if (value === 307) return true;
};
